// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"eaadedf2","337":"d94c64e5","376":"77d906f3","536":"7e9dc906","566":"815b08c1","585":"5f514b19","642":"ba8d2403","787":"1d4f7168","831":"347c852a"}[chunkId] + ".chunk.js";
};